module.exports = __webpack_public_path__ + "img/celtic-fc.ce072300.png";